export default {
    login({ commit }, user) {
        commit('login', user);
    },
    logoff({ commit }) {
        commit('logoff');
    },
    register({ commit }, user) {
        commit('register', user);
    }
}
